module.exports = __webpack_public_path__ + "media/02Desktop_Mock_Sustain_Home.3559b881.mp4";